<template>
    <el-skeleton :rows="12" animated :loading="false">
        <template #default>
            <div class="text-center">
                <div>
                    Nome: <strong>{{ affiliate.user.name }}</strong>
                </div>
                <div>
                    Telefone: <strong>{{ affiliate.user.phone }}</strong>
                </div>
                <div>
                    Saldo Total: <strong class="text-success">{{ affiliate.balance.toFixed(2) }}MT</strong>
                </div>
                <div>
                    Afiliado desde: <strong class="text-primary">{{ new Date(affiliate.created_at ?? 0).toLocaleString() }}</strong>
                </div>
                <div>
                    C&oacute;digo: <strong>{{ affiliate.id }}</strong>
                </div>
                <div>
                    Link de afiliado:
                    <a target="_blank" :href="`https://beasymoz.com?affiliate_id=${affiliate.id}`" class="text-success">
                        {{ `https://beasymoz.com?affiliate_id=${affiliate.id}` }}
                    </a>
                </div>
            </div>
        </template>
    </el-skeleton>
</template>

<script lang="ts" setup>
    import { Affiliate } from "@/services/types/affiliate";
    import { ElDivider, ElMessage, FormInstance, FormRules } from "element-plus"

    const props = defineProps<{
        affiliate: Affiliate
    }>()
</script>
